<template>
  <div class="lines-container">

    <!-- ========== ENCABEZADO ========== -->
    <section class="lines-header">
      <h1 class="lines-header__title">Líneas Conectadas</h1>
      <p class="lines-header__subtitle">
        Estas son las líneas activas vinculadas a Meta vía API.
      </p>
    </section>

    <!-- ========== CUERPO ========== -->
    <div class="table-wrapper">

      <!-- ========== SPINNER DE CARGA ========== -->
      <div v-if="loading" class="loading-spinner">
        <span class="spinner"></span>
        <p>Cargando Líneas...</p>
      </div>

      <!-- ========== TABLA DE LÍNEAS CONECTADAS ========== -->
      <div v-else class="users-table-container">
        <table class="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Estado</th>
            </tr>
          </thead>

          <tbody>
            <!-- ========== MENSAJE SI NO HAY LÍNEAS ========== -->
            <tr v-if="lines.length === 0">
              <td colspan="4" class="no-data">No hay líneas disponibles</td>
            </tr>

            <!-- ========== FILAS DE LÍNEAS ========== -->
            <tr v-for="line in lines" :key="line.id">
              <td>{{ line.id }}</td>
              <td class="cell-name">{{ line.line_name }}</td>
              <td>{{ line.phone_number }}</td>
              <td>
                <span :class="['status-badge', line.status === 'active' ? 'active' : 'inactive']">
                  {{ line.status === 'active' ? 'Activa' : 'Inactiva' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ConnectedLinesTable",

  // ========== ESTADO LOCAL ==========
  data() {
    return {
      lines: [],         // Arreglo con las líneas obtenidas desde la API
      loading: true      // Estado de carga para mostrar el spinner
    };
  },

  // ========== CICLO DE VIDA ==========
  mounted() {
    this.fetchLines(); // Carga inicial al montar el componente
  },

  // ========== MÉTODOS ==========
  methods: {
    // Llama al backend para obtener las líneas conectadas
    async fetchLines() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/lines");

        // Verifica si la respuesta contiene un arreglo válido
        if (Array.isArray(response.data)) {
          this.lines = response.data;
        } else {
          console.error("Respuesta inesperada del servidor:", response.data);
          this.lines = []; // Vacía por si llega un valor inválido
        }

      } catch (error) {
        console.error("Error al obtener las líneas desde el backend:", error);
      } finally {
        this.loading = false; // Siempre desactiva el estado de carga
      }
    }
  }
};
</script>

<style scoped>
.lines-container {
  padding: 20px;
  background: #f9fafb;
  height: 100vh;
  overflow-y: auto;  
}

/* ========== ENCABEZADO ========== */
.lines-header {
  margin: 0;
  text-align: left;
  font-family: 'Manrope', sans-serif;
  margin-bottom: 30px;
}

.lines-header__title {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.lines-header__subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #64748b;
  margin: 0;
}

/* ========== CONTENEDOR DE TABLA / BLOQUES ========== */
.users-table-container {
  overflow-x: auto;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  background-color: #fff;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 3rem;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Manrope', sans-serif;
}

.users-table th {
  text-align: left;
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #475569;
  background-color: #f1f1f1;
  border-bottom: 1px solid #e2e8f0;
}

.users-table td {
  padding: 0.85rem 1rem;
  font-size: 0.95rem;
  color: #0f172a;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

.cell-name {
  font-weight: 600;
  color: #1e293b;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 9999px;
  white-space: nowrap;
  line-height: 1;
  transition: background-color 0.25s ease, color 0.25s ease;
}

.status-badge.active {
  background-color: rgba(22, 163, 74, 0.15);
  color: #16a34a;
  border: 1px solid rgba(22, 163, 74, 0.25);
}

.status-badge.inactive {
  background-color: rgba(220, 38, 38, 0.1);
  color: #dc2626;
  border: 1px solid rgba(220, 38, 38, 0.2);
}

/* ========== SPINNER DE CARGA ========== */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 1 / -1;
  padding: 60px 20px;
  font-size: 16px;
  color: #64748b;
  gap: 16px;
  font-family: 'Manrope', sans-serif;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s ease-in-out infinite;
  position: relative;
}

.spinner::after {
  content: '';
  position: absolute;
  top: -8px;
  left: -8px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.1);
  animation: pulse 1.6s infinite ease-in-out;
}

/* ========== ANIMACIONES ========== */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.2;
  }
}

/* ========== MENSAJE DE VACÍO ========== */
.no-data {
  text-align: center;
  padding: 2rem;
  color: #94a3b8;
  font-style: italic;
}
</style>
